"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = Progress;

var _react = _interopRequireWildcard(require("react"));

var _ = require(".");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Progress(_ref) {
  var completed = _ref.completed,
      children = _ref.children,
      Indicator = _ref.indicator;
  var loader = (0, _.useLoader)();

  var _ref2 = (0, _react.useState)(undefined),
      _ref3 = _slicedToArray(_ref2, 2),
      loaded = _ref3[0],
      setLoaded = _ref3[1];

  (0, _react.useEffect)(function () {
    var progress = function progress(_loader, resource) {
      return setLoaded(resource);
    };

    loader.on('progress', progress);
    return function () {
      loader.removeListener('progress', progress);
    };
  }, []);
  return _react.default.createElement(_react.default.Fragment, null, completed ? children : Indicator == null ? null : _react.default.createElement(Indicator, {
    progress: loader.progress,
    resource: loaded
  }));
}